var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"default-logo"},on:{"click":_vm.toApplicationList}},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"height":"45","alt":"Logo"}}),_c('div',{attrs:{"id":"default-logo-txt"}},[_vm._v("for Developers")])])}
var staticRenderFns = []

export { render, staticRenderFns }